import React, { useState } from "react"
import { useInView } from "react-intersection-observer"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { useMediaQuery } from "../../hook/mediaQueryHooks"
import logo from "../../images/Auryxia-logo.svg"
import hmIcon from "../../images/home-icon.svg"
import EntryModal from "../shared/entry-modal"
//import RequestSamplesModal from "../shared/request-samples-modal"

const url = typeof window !== "undefined" ? window.location.pathname : ""

const ListLink = props => (
    <li className={props.className}>
        <Link to={props.to} data-title={props.title}>
            {props.children}
        </Link>
    </li>
)
const openIsiTray = event => {
    event.preventDefault()
    setTimeout(function () {
        var psp = document.querySelector("#psp-panel")
        psp.setAttribute("data-state", "tallbutcollapse")
        document.body.classList.add("no-overflow")
    }, 300)
}

function removeErrorStates() {
    if (
        document.getElementById("first-name") ||
        document.getElementById("last-name")
    ) {
        document.getElementById("first-name").classList.remove("error_state")
        document.getElementById("last-name").classList.remove("error_state")
    }
}
function AbtAuryxiaLink(props) {
    const [isActive, setActive] = useState(false)

    // var match = url.match("/about-auryxia/");
    var match = url.match("/mechanism-of-action/")
    var match2 = url.match("/patient-profiles/")
    var match3 = url.match("/resources/")

    const toggleClass = event => {
        event.preventDefault()
        setActive(!isActive)
    }

    return (
        <a
            href="#about-auryxia"
            className={isActive ? "open" : null}
            onClick={toggleClass}
            id="aboutMenuHP"
            data-path={match || match2 || match3 ? "true" : "false"}
            data-title="About AURYXIA"
        >
            <span>About AURYXIA</span>
            <i></i>
        </a>
    )
}

function SafetyLink(props) {
    const [isActive, setActive] = useState(false)
    const url = typeof window !== "undefined" ? window.location.pathname : ""
    var match = url.match("/safety/")

    const toggleClass = event => {
        event.preventDefault()
        setActive(!isActive)
    }

    return (
        <a
            href="#safety"
            className={isActive ? "open" : null}
            onClick={toggleClass}
            id="safetyMenuHP"
            data-path={match ? "true" : "false"}
            data-title="Safety"
        >
            <span>Safety</span>
            <i></i>
        </a>
    )
}

function ConnectLink(props) {
    const [isActive, setActive] = useState(false)

    const toggleClass = event => {
        event.preventDefault()
        setActive(!isActive)
    }

    return (
        <a
            href="#connect"
            className={isActive ? "open" : null}
            onClick={toggleClass}
            data-title="CONNECT"
        >
            <span>GET AURYXIA</span>
            <i></i>
        </a>
    )
}

const toggleModes = {
    auto: 0,
    forceOpen: 1,
    forceClose: 2,
}

const toggleBurger = (event, toggleMode = toggleModes.auto) => {
    var header = document.querySelector("#hpp-navigation"),
        newMenuOpenState = null

    switch (toggleMode) {
        case toggleModes.auto:
            newMenuOpenState = !header.classList.contains("open")
            break

        case toggleModes.forceOpen:
            if (!header.classList.contains("open")) newMenuOpenState = true
            break

        case toggleModes.forceClose:
            if (header.classList.contains("open")) newMenuOpenState = false
            break

        default:
            break
    }

    // If newMenuOpenState is null, don't make any changes to the menu's open state.
    // otherwise, we're opening or closing the menu based on whether it has been set
    // to true or false
    if (newMenuOpenState !== null) {
        var backdrop = document.querySelector("#header-backdrop"),
            pgheader = document.querySelector("header"),
            body = document.querySelector("body")

        if (newMenuOpenState) {
            // Open the menu
            body.classList.add("no-select")
            backdrop.style.display = "block"
            header.classList.add("open")
            pgheader.classList.add("open")
        } else {
            // Close the menu
            body.classList.remove("no-select")
            backdrop.style.display = "none"
            header.classList.remove("open")
            pgheader.classList.remove("open")
        }
    }
    removeErrorStates()
}

const CloseOpenMenu = () => {
    const mobile = useMediaQuery("(min-width: 767px)")

    if (mobile === true) {
        let myBackdrop = document.querySelector("#header-backdrop"),
            myHeader = document.querySelector("#hpp-navigation"),
            pageHeader = document.querySelector("header"),
            myBody = document.querySelector("body")

        if (myHeader !== null && myHeader.classList.contains("open") === true) {
            myBody.classList.remove("no-select")
            myBackdrop.style.display = "none"
            myHeader.classList.remove("open")
            pageHeader.classList.remove("open")
        }
        return <span className="hidden">m</span>
    } else {
        return <span className="hidden">d</span>
    }
}

function StickyHeader({
    props,
    location,
    siteTitle,
    entryModalShown,
    siteAudience,
    externalLink,
}) {
    const { ref, inView } = useInView({
        /* Optional options */
        threshold: 0.5,
        initialInView: true,
    })

    return (
        <header
            aria-label={siteTitle + " header"}
            id="hpp"
            ref={ref}
            className={inView ? null : "sticky"}
        >
            {entryModalShown}
            {entryModalShown && (
                <EntryModal
                    siteAudience={siteAudience}
                    externalLink="https://www.auryxia.com/hyperphosphatemia/patients/"
                />
            )}
            <div id="hpp-navigation">
                <div className="flex-row">
                    <div id="auryxia-logo" aria-label="Auryxia Physician logo">
                        <Link to="/" title="Home">
                            <img
                                src={logo}
                                alt="AURYXIA® (ferric citrate) tablets"
                            />
                        </Link>
                    </div>

                    <div
                        id="header-navigation"
                        className="header-navigation"
                        aria-label="Auryxia Physician Navigation Menu"
                    >
                        <div className="navigation secondary">
                            <ul>
                                <li>
                                    <a
                                        href="#isi"
                                        onClick={openIsiTray}
                                        className="anchor-link"
                                    >
                                        Important Safety Information
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.auryxia.com/wp-content/uploads/Auryxia_PI.pdf"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Full Prescribing Information
                                    </a>
                                </li>
                                <li className="large-only">
                                    <a href="https://www.auryxia.com/">
                                        For Patients
                                    </a>
                                </li>
                                <li className="large-only">
                                    <a href="https://akebia.com/connect/">
                                        AkebiaCares
                                    </a>
                                </li>
                                <ListLink
                                    to="/iron-deficiency-anemia/"
                                    className="large-only"
                                >
                                    Iron Deficiency Anemia
                                </ListLink>
                            </ul>
                            <p>FOR US HEALTHCARE PROFESSIONALS</p>
                        </div>

                        <p className="small-only">
                            For the control of serum phosphorus levels in adult
                            patients with chronic kidney disease on dialysis
                        </p>

                        <div
                            id="hamburger"
                            onClick={toggleBurger}
                            onKeyDown={toggleBurger}
                            role="button"
                            tabIndex={0}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div id="site-navigation" className="hpp">
                    <p className="large-only">
                        For the control of serum phosphorus levels in adult
                        patients with chronic kidney disease on dialysis
                    </p>
                    <div className="flex-row">
                        <div className="site-navigation">
                            <nav>
                                <ul>
                                    <li className="home">
                                        <Link
                                            to="/hyperphosphatemia-treatment/"
                                            activeClassName="active"
                                            id="homeLinkHpp"
                                            onClick={e =>
                                                toggleBurger(
                                                    e,
                                                    toggleModes.forceClose
                                                )
                                            }
                                        >
                                            <img
                                                className="home-icon"
                                                src={hmIcon}
                                                alt="Icon shaped like a house to navigate to the home page"
                                            />
                                            <span>Home</span>
                                        </Link>
                                    </li>
                                    <li className="submenu">
                                        <AbtAuryxiaLink />
                                        <ul>
                                            <li>
                                                <Link
                                                    to="/hyperphosphatemia/mechanism-of-action/"
                                                    data-title="Mechanism of Action"
                                                    activeClassName="active"
                                                    onClick={e =>
                                                        toggleBurger(
                                                            e,
                                                            toggleModes.forceClose
                                                        )
                                                    }
                                                >
                                                    Mechanism of Action
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/hyperphosphatemia/patient-profiles/"
                                                    data-title="Patient Profile"
                                                    activeClassName="active"
                                                    onClick={e =>
                                                        toggleBurger(
                                                            e,
                                                            toggleModes.forceClose
                                                        )
                                                    }
                                                >
                                                    Patient Profiles
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/hyperphosphatemia/resources/"
                                                    data-title="Resources"
                                                    activeClassName="active"
                                                    onClick={e =>
                                                        toggleBurger(
                                                            e,
                                                            toggleModes.forceClose
                                                        )
                                                    }
                                                >
                                                    Resources
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link
                                            to="/hyperphosphatemia/ferric-citrate-efficacy/"
                                            activeClassName="active"
                                            onClick={e =>
                                                toggleBurger(
                                                    e,
                                                    toggleModes.forceClose
                                                )
                                            }
                                        >
                                            Efficacy
                                        </Link>
                                    </li>
                                    <li className="submenu">
                                        <SafetyLink />
                                        <ul>
                                            <li>
                                                <Link
                                                    to="/hyperphosphatemia/ferric-citrate-reactions/"
                                                    data-title="Adverse Reactions"
                                                    activeClassName="active"
                                                    onClick={e =>
                                                        toggleBurger(
                                                            e,
                                                            toggleModes.forceClose
                                                        )
                                                    }
                                                >
                                                    Adverse Reactions
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to="/hyperphosphatemia/pharmacodynamics/"
                                                    data-title="Pharmacodynamics"
                                                    activeClassName="active"
                                                    onClick={e =>
                                                        toggleBurger(
                                                            e,
                                                            toggleModes.forceClose
                                                        )
                                                    }
                                                >
                                                    Pharmacodynamics
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <Link
                                            to="/hyperphosphatemia/dosing/"
                                            activeClassName="active"
                                            onClick={e =>
                                                toggleBurger(
                                                    e,
                                                    toggleModes.forceClose
                                                )
                                            }
                                        >
                                            Dosing
                                        </Link>
                                    </li>

                                    <li className="small-only">
                                        <a href="https://www.auryxia.com/">
                                            For Patients
                                        </a>
                                    </li>
                                    <li className="small-only">
                                        <a href="https://akebia.com/connect/">
                                            AkebiaCares
                                        </a>
                                    </li>
                                    <li className="small-only">
                                        <a href="/iron-deficiency-anemia/">
                                            Iron Deficiency Anemia
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

const HppHeader = ({ location, siteTitle, entryModalShown, siteAudience }) => (
    <>
        <StickyHeader
            location={location}
            siteTitle={siteTitle}
            siteAudience={siteAudience}
            entryModalShown={entryModalShown}
        />
        <CloseOpenMenu />
    </>
)

HppHeader.propTypes = {
    siteTitle: PropTypes.string,
}

HppHeader.defaultProps = {
    siteTitle: `AURYXIA® (ferric citrate) tablets`,
}

export default HppHeader
